import store from "@/store/index";
//import notifications from "@/components/common/notifications";
import patientAPI from "@/api/patientAPI.js";
//import permissions from "@/api/permissions.js";

export default {
  data: () => ({
    vrAuditTrail: [],
    options: {},
    tblLoading: false,
    totalRecords: 0,
    headers: [
      {
        sortable: false,
        width: "15%",
        text: "EVENT TYPE",
        value: "event_type_name",
      },
      {
        sortable: false,
        width: "25%",
        text: "REMOTE SERVICE",
        value: "remote_serv_name",
      },
      {
        sortable: false,
        width: "10%",
        text: "CHANNEL",
        value: "channel_type_name",
      },
      {
        sortable: false,
        width: "15%",
        text: "LETTER TYPE",
        value: "letter_type_name",
      },
      {
        sortable: false,
        width: "20%",
        text: "INITIATOR",
        value: "create_by_name",
      },
      { sortable: false, width: "15%", text: "DATE", value: "create_date" },
    ],
    //options
  }),
  props: ["patient_id"],
  watch: {
    options: {
      handler() {
        this.loadAuditTrail();
      },
      deep: true,
    },
    patient_id: {
      handler() {
        this.loadAuditTrail();
      },
    },
  },
  methods: {
    loadAuditTrail() {
      this.tblLoading = true;
      if (this.patient_id == null) {
        this.vrAuditTrail = [];
        this.totalRecords = 0;
        this.tblLoading = false;
        return;
      }
      patientAPI
        .getAuditTrail({
          //patient_id: this.vrPatientID,
          patient_id: this.patient_id,
          pagination: this.options,
        })
        .then((response) => {
          if (response.data.results !== null) {
            this.vrAuditTrail = response.data.results.audit_trail;
            this.totalRecords =
              response.data.results.AuditTrailCount.total_count;
          }
        }).then(()=>{
          this.tblLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {});
    },
  },
  mounted() {
    //this.snackbar = false
  },
  computed: {
    vrNotify() {
      return store.state.notify;
    },
    vrPatientID() {
      return store.state.patientId;
    },
  },
};
